/**
 * Map years to nostalgic icons/emojis
 * Each year gets a unique emoji that represents memories or pop culture from that era
 * 
 * - 2025 —  (book)
- 2024 — 🎓 (graduation)
- 2023 — 🏋️ (training)
- 2022 — 🎮 

 */



export const yearIconMap = {
  // 2020s
  2025: { emoji: '🎵', label: 'Phone Era' },
  2024: { emoji: '🎵', label: 'Phone Era' },
  2023: { emoji: '🎵', label: 'Streaming' },
  2022: { emoji: '🎵', label: 'Gaming' },
  2021: { emoji: '🎵', label: 'Remote' },
  2020: { emoji: '🎵', label: 'Home' },
  2019: { emoji: '🎵', label: 'Live Music' },
  2018: { emoji: '🎵', label: 'Vocals' },



  default: { emoji: '🎵', label: 'Music' }
};

/**
 * Get the icon and label for a specific year
 */
export function getYearIcon(year) {
  const yearNum = parseInt(year);
  return yearIconMap[yearNum] || yearIconMap.default;
}

/**
 * Get just the emoji for a year
 */
export function getYearEmoji(year) {
  return getYearIcon(year).emoji;
}

/**
 * Get the label for a year
 */
export function getYearLabel(year) {
  return getYearIcon(year).label;
}
